export const listingSortDisplayStrings: Record<string, string> = {
  "a-z": "A - Z",
  default: "Recommended",
  distance: "Distance",
  "highest-rated": "Highest rated",
  "most-reviews": "Most reviews",
  "online-ordering": "Online Ordering",
  "z-a": "Z - A",
};
